import { Pipe, PipeTransform } from '@angular/core';
import { AuthRepository } from 'app/core/auth/auth.repository';

/**
 * ProfileImageUrlPipe
 *
 * Appends the current JWT as `?token=` to a profile image serve URL.
 * Profile images are stored outside the web root and served via the
 * authenticated endpoint GET /v1/account/profile-image/{userId}.
 *
 * Usage in templates:
 *   <img [src]="user?.profile_image | profileImageUrl" />
 *
 * Returns an empty string if the URL is falsy (no image configured).
 */
@Pipe({
  name: 'profileImageUrl',
  standalone: true,
  pure: false, // re-evaluate if the access token refreshes
})
export class ProfileImageUrlPipe implements PipeTransform {
  constructor(private _auth: AuthRepository) {}

  transform(url: string | null | undefined): string {
    if (!url) { return ''; }
    // Pass through data: URLs (local previews) and already-tokenized URLs unchanged
    if (url.startsWith('data:') || url.includes('?token=')) { return url; }
    const token = this._auth.getAccessToken();
    return token ? `${url}?token=${encodeURIComponent(token)}` : url;
  }
}
